// import React from "react";
// import { Link } from "react-router-dom"; // 👈 import add karna

// function Header() {
//   return (
//     <header className="main-header main-header--one clearfix">
//       <div className="main-header--one__top clearfix">
//         <div className="container">
//           <div className="main-header--one__top-inner clearfix">
//             <div className="main-header--one__top-left">
//               <div className="main-header--one__top-logo">
//                 <a href="#home">
//                   <img src="assets/images/suhani/logonew.png" alt="Logo" />
//                 </a>
//               </div>
//             </div>
//             <div className="main-header--one__top-right clearfix">
//               <ul className="main-header--one__top-social-link list-unstyled clearfix">
//                 <li><a href="https://www.facebook.com/suhanibuilder" target="_blank" rel="noreferrer"><i className="fab fa-facebook"></i></a></li>
//                 <li><a href="#"><i className="fab fa-instagram"></i></a></li>
//               </ul>
//               <div className="main-header--one__top-contact-info clearfix">
//                 <ul className="main-header--one__top-contact-info-list list-unstyled">
//                   <li className="main-header--one__top-contact-info-list-item">
//                     <div className="icon"><span className="icon-phone-call-1"></span></div>
//                     <div className="text">
//                       <h6>Call Us</h6>
//                       <p><a href="tel:+1 (732) 668 8291">+1 (732) 668 8291</a></p>
//                     </div>
//                   </li>
//                   <li className="main-header--one__top-contact-info-list-item">
//                     <div className="icon"><span className="icon-message"></span></div>
//                     <div className="text">
//                       <h6>Contact Us</h6>
//                       <p><a href="mailto:suhanibuilders@gmail.com">suhanibuilders@gmail.com</a></p>
//                     </div>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="main-header-one__bottom clearfix">
//         <div className="container">
//           <div className="main-header-one__bottom-inner clearfix">
//             <nav className="main-menu main-menu--1">
//               <div className="main-menu__inner menu-mobile">
//                 <a href="#" className="mobile-nav__toggler"><i className="fa fa-bars"></i></a>
//                 <div className="left">
//                   <ul className="main-menu__list one-page-scroll-menu">
//                <li><Link to="/">Home</Link></li>
// <li><Link to="/#aboutus">About Us</Link></li>
// <li><Link to="/#gallery">Gallery</Link></li>
// <li><Link to="/#testimonial">Testimonials</Link></li>
// <li><Link to="/#contactus">Contact Us</Link></li>
//                   </ul>
//                 </div>
//               </div>
//             </nav>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// }

// export default Header;


import React, { useState } from "react";
import { Link } from "react-router-dom";

function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      {/* ===== HEADER ===== */}
      <header className="main-header main-header--one clearfix">
        <div className="main-header--one__top clearfix">
          <div className="container">
            <div className="main-header--one__top-inner clearfix">
              <div className="main-header--one__top-left">
                <div className="main-header--one__top-logo">
                  <a href="/">
                    <img
                      src="assets/images/suhani/logonew.png"
                      alt="Suhani Builders"
                    />
                  </a>
                </div>
              </div>

              <div className="main-header--one__top-right clearfix">
                <ul className="main-header--one__top-social-link list-unstyled clearfix">
                  <li>
                    <a
                      href="https://www.facebook.com/suhanibuilder"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                </ul>

                <div className="main-header--one__top-contact-info clearfix">
                  <ul className="main-header--one__top-contact-info-list list-unstyled">
                    <li className="main-header--one__top-contact-info-list-item">
                      <div className="icon">
                        <span className="icon-phone-call-1"></span>
                      </div>
                      <div className="text">
                        <h6>Call Us</h6>
                        <p>
                          <a href="tel:+17326688291">+1 (732) 668 8291</a>
                        </p>
                      </div>
                    </li>

                    <li className="main-header--one__top-contact-info-list-item">
                      <div className="icon">
                        <span className="icon-message"></span>
                      </div>
                      <div className="text">
                        <h6>Contact Us</h6>
                        <p>
                          <a href="mailto:suhanibuilders@gmail.com">
                            suhanibuilders@gmail.com
                          </a>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== BOTTOM NAV ===== */}
        <div className="main-header-one__bottom clearfix">
          <div className="container">
            <div className="main-header-one__bottom-inner clearfix">
              <nav className="main-menu main-menu--1">
                <div className="main-menu__inner menu-mobile">
                  {/* MOBILE TOGGLER */}
                  <a
                    href="#"
                    className="mobile-nav__toggler"
                    onClick={(e) => {
                      e.preventDefault();
                      setMobileOpen(true);
                    }}
                  >
                    <i className="fa fa-bars"></i>
                  </a>

                  {/* DESKTOP MENU */}
                  <div className="left">
                    <ul className="main-menu__list one-page-scroll-menu">
                                  <li><Link to="/">Home</Link></li>
 <li><Link to="/#aboutus">About Us</Link></li>
 <li><Link to="/#gallery">Gallery</Link></li>
 <li><Link to="/#testimonial">Testimonials</Link></li>
  <li><Link to="/#ourteam">Our Team</Link></li>
 <li><Link to="/#contactus">Contact Us</Link></li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>

      {/* ===== MOBILE MENU (IMAGE JESA) ===== */}
      <div className={`mobile-nav__wrapper ${mobileOpen ? "expanded" : ""}`}>
        <div
          className="mobile-nav__overlay"
          onClick={() => setMobileOpen(false)}
        ></div>

        <div className="mobile-nav__content dark-menu">
          {/* TOP */}
    <div className="mobile-menu-top">
  <img
    src="assets/images/suhani/whitelogo.png"
    alt="Suhani Builders"
    className="mobile-logo"
  />
  <span
    className="mobile-nav__close"
    onClick={() => setMobileOpen(false)}
  >
    ✕
  </span>
</div>


          {/* LINKS */}
          <ul className="mobile-menu-links">
            <li
            style={{
                borderTop: '1px solid #2a2d3a',

            }}
            ><a href="#home" onClick={() => setMobileOpen(false)}>Home</a></li>
            <li><a href="#aboutus" onClick={() => setMobileOpen(false)}>About Us</a></li>
            <li><a href="#gallery" onClick={() => setMobileOpen(false)}>Gallery</a></li>
            <li><a href="#testimonial" onClick={() => setMobileOpen(false)}>Testimonials</a></li>
            <li><a href="#ourteam" onClick={() => setMobileOpen(false)}>Our Team</a></li>
            <li><a href="#contactus" onClick={() => setMobileOpen(false)}>Contact Us</a></li>
          </ul>

          {/* CONTACT (RED ICONS) */}
        <div className="mobile-menu-contact">
  <div className="contact-row">
    <span className="contact-icon">
      <i className="icon-letter"></i>
    </span>
    <span className="contact-text">
      suhanibuilders@gmail.com
    </span>
  </div>

  <div className="contact-row">
    <span className="contact-icon">
      <i className="icon-phone-call"></i>
    </span>
    <span className="contact-text">
      +1 (732) 668 8291
    </span>
  </div>
</div>


          {/* SOCIAL */}
          <div className="mobile-menu-social">
            <a href="https://www.facebook.com/suhanibuilder" target="_blank" rel="noreferrer">
              <i className="fab fa-facebook-square"></i>
            </a>
            <a href="#" style={{marginLeft: '30px'}}>
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;

